import React, { SyntheticEvent } from 'react';
import './style.scss';
import DatePicker from 'react-datepicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface Props {
    id: string
    selectedTime: Date | null
    // eslint-disable-next-line no-unused-vars
    handleChange: (date: Date | null, event: SyntheticEvent<any, Event> | undefined) => void
    label?: string | undefined
    className?: string | undefined
    maxTime?: Date | undefined
    minTime?: Date | undefined
  }

const TimePicker: React.FC<Props> = (props) => {
  const {
    id, selectedTime, handleChange, label, className,
    maxTime, minTime,
  } = props;
  return (
    <div className={`w-100 ${className}`}>
      <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
      <div className="w-100 position-relative d-flex align-items-center">
        <AccessTimeIcon style={{
          position: 'absolute',
          left: 20,
          color: '#A6A6A6',
        }}
        />
        <DatePicker
          id={id}
          onChange={handleChange}
          selected={selectedTime}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={10}
          dateFormat="hh:mm aa"
          className="input-timepicker-range"
          maxTime={maxTime}
          minTime={minTime}
        />
      </div>
    </div>
  );
};

export default TimePicker;
